module.exports = __webpack_public_path__ + "static/media/oxygen-tank.b80b4ca9.svg";